(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.Search = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var Search = function (_React$Component) {
    _inherits(Search, _React$Component);

    function Search(props) {
      _classCallCheck(this, Search);

      var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

      var minWidth = _this.props.minWidth;

      _this.state = {
        hover: false
      };
      _this.open = {
        width: minWidth > 355 ? minWidth + 'px' : '305px',
        marginLeft: minWidth > 355 ? '-' + (minWidth - 50) + 'px' : '-255px'
      };
      _this.closed = {
        width: '40px',
        marginLeft: '0'
      };
      _this.handleHover = _this.handleHoverEvent.bind(_this);
      return _this;
    }

    _createClass(Search, [{
      key: 'getStyle',
      value: function getStyle(prop) {
        if (this.props.isMobile) {
          // Always closed if isMobile
          return this.closed[prop];
        }

        return this[this.props.searchOpen ? 'open' : 'closed'][prop];
      }
    }, {
      key: 'handleHoverEvent',
      value: function handleHoverEvent() {
        this.setState({
          hover: !this.state.hover
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var minWidth = this.props.minWidth;
        this.open = {
          width: minWidth > 355 ? minWidth + 50 + 'px' : '305px',
          marginLeft: minWidth > 355 ? '-' + (minWidth + 10) + 'px' : '-255px'
        };

        if (!this.props.hasSearch) {
          return false;
        }

        var searchBoxStyles = {
          position: 'relative',
          width: '40px',
          height: '47px',
          margin: '14px 0 14px'
        };
        var searchSliderStyles = {
          width: this.getStyle('width'),
          height: '47px',
          marginLeft: this.getStyle('marginLeft'),
          backgroundColor: '#000',
          overflow: 'hidden',
          transition: 'all 0.25s ease-in-out'
        };
        var inputStyles = {
          margin: 0,
          padding: '11px 6px 6px',
          display: 'inline-block',
          textDecoration: 'none',
          fontSize: '20px',
          lineHeight: '19px',
          fontWeight: 100,
          color: '#fff',
          outline: 'none',
          maxWidth: '200px',
          backgroundColor: '#000',
          border: 'none'
        };
        var buttonStyles = {
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50%',
          backgroundImage: 'url(https://www.concur.com/sites/all/modules/custom_concur/concur_search/images/ico-arrow.png)',
          boxShadow: 'none',
          padding: '9px 25px 11px',
          margin: 0,
          minWidth: 0,
          marginTop: '-8px'
        };

        buttonStyles.backgroundColor = this.state.hover ? '#92cb53' : '#89bf42';

        return _react2.default.createElement(
          'div',
          {
            style: searchBoxStyles,
            className: 'menu-search-box pull-right'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'menu-search-slider',
              style: searchSliderStyles
            },
            _react2.default.createElement(
              'div',
              {
                className: 'menu-search-form',
                style: {
                  width: '305px',
                  marginLeft: this.props.searchOpen ? parseInt(this.open.width, 10) - 305 + 'px' : 0,
                  transition: 'all 0.25s ease-in-out'
                }
              },
              _react2.default.createElement('div', {
                style: {
                  backgroundImage: 'url(https://www.concur.com/sites/all/modules/custom_concur/concur_search/images/ico-search.png)',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: '50%',
                  cursor: 'pointer',
                  height: '48px',
                  width: '39px',
                  float: 'left',
                  display: this.props.open && this.props.isMobile ? 'none' : 'block'
                },
                className: 'toggle-search',
                onClick: this.props.toggleSearch
              }),
              _react2.default.createElement(
                'form',
                {
                  id: 'menu-search-form',
                  action: '/search',
                  style: {
                    float: 'left',
                    display: this.props.open && this.props.isMobile ? 'none' : 'block'
                  }
                },
                _react2.default.createElement('input', {
                  id: 'e-search-input',
                  name: 'sqs',
                  size: '30',
                  maxLength: '128',
                  placeholder: this.props.placeholder,
                  style: inputStyles
                }),
                _react2.default.createElement('input', {
                  type: 'submit',
                  name: 'submit',
                  onMouseEnter: this.handleHover,
                  onMouseLeave: this.handleHover,
                  className: 'btn light-green bg-icon',
                  value: '',
                  style: buttonStyles
                })
              )
            )
          )
        );
      }
    }]);

    return Search;
  }(_react2.default.Component);

  exports.default = Search;


  Search.propTypes = {
    placeholder: _propTypes2.default.string,
    minWidth: _propTypes2.default.number,
    hasSearch: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool,
    open: _propTypes2.default.bool,
    searchOpen: _propTypes2.default.bool,
    toggleSearch: _propTypes2.default.func
  };

  Search.defaultProps = {
    placeholder: 'Search',
    hasSearch: false
  };
});